export default __webpack_public_path__ + "static/media/collections-option2.42be5cc0.jpg";